export default __webpack_public_path__ + "static/media/react.cd3924de.png";